import { useEffect, useState } from 'react'
import { api } from '../api'

interface HomeConfig {
  hero_title: string
  hero_subtitle: string
  logo_url: string
}

export default function HomeConfigPage() {
  const [form, setForm] = useState<HomeConfig>({ hero_title: '', hero_subtitle: '', logo_url: '' })
  const [saving, setSaving] = useState(false)
  const [uploading, setUploading] = useState(false)
  const [message, setMessage] = useState('')

  useEffect(() => {
    api.get('/api/admin/home-config').then((res) => {
      if (res.success && res.data) {
        setForm({
          hero_title: res.data.hero_title || '',
          hero_subtitle: res.data.hero_subtitle || '',
          logo_url: res.data.logo_url || '',
        })
      }
    })
  }, [])

  const update = (key: keyof HomeConfig, value: string) => {
    setForm((prev) => ({ ...prev, [key]: value }))
  }

  const handleUpload = async (file: File) => {
    setUploading(true)
    const formData = new FormData()
    formData.append('file', file)
    const res = await api.post('/api/admin/upload', formData)
    if (res.success && res.data?.url) {
      update('logo_url', res.data.url)
    } else {
      alert(res.error || '上传失败')
    }
    setUploading(false)
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setSaving(true)
    setMessage('')

    const res = await api.put('/api/admin/home-config', form)
    if (res.success) {
      setMessage('保存成功')
    } else {
      setMessage(res.error || '保存失败')
    }
    setSaving(false)
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">首页配置</h1>
      </div>

      <form onSubmit={handleSubmit} style={{ maxWidth: '560px' }}>
        <div style={{ background: 'white', padding: '24px', borderRadius: '8px', marginBottom: '16px' }}>
          <div className="form-group">
            <label className="form-label">Hero 标题</label>
            <input className="form-input" value={form.hero_title} onChange={(e) => update('hero_title', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Hero 副标题</label>
            <input className="form-input" value={form.hero_subtitle} onChange={(e) => update('hero_subtitle', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Logo URL</label>
            {form.logo_url && (
              <img src={form.logo_url} alt="logo" style={{ height: '48px', objectFit: 'contain', marginBottom: '8px', display: 'block' }} />
            )}
            <input className="form-input" value={form.logo_url} onChange={(e) => update('logo_url', e.target.value)} placeholder="URL 或上传" />
            <input type="file" accept="image/*" style={{ marginTop: '8px' }} onChange={(e) => { const f = e.target.files?.[0]; if (f) handleUpload(f) }} />
            {uploading && <p style={{ color: 'var(--color-primary)', fontSize: '13px', marginTop: '4px' }}>上传中...</p>}
          </div>
        </div>

        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? '保存中...' : '保存'}
          </button>
          {message && (
            <span style={{ fontSize: '14px', color: message.includes('成功') ? 'var(--color-success)' : 'var(--color-danger)' }}>
              {message}
            </span>
          )}
        </div>
      </form>
    </div>
  )
}
